// extracted by mini-css-extract-plugin
export default {"loading-spinner":"PageLoader_loading-spinner__iC1H9","rotate":"PageLoader_rotate__Xfmtp"};